import { IAssetRentRequestCardItem } from '@interfaces/rent/assetRent';

export const tooltipsText = {
	youIncluded: 'You have been included in the Approval Unit. Please approve the asset.',
	youNotIncluded: 'You are not included in the Approval Unit and only have view access to the approvals of other users',
	noApprovalUnits: `Approval has not been assigned to any users yet.
	Please contact your manager to assign Approval Units to the current Asset type.`,
	atLeaseOneRejected: 'One or more members of the Approval Unit have rejected this asset request',
	allApproved: 'All members have approved the asset request',
};

export function getCorrectTooltipForApprovalBtn({
	asset,
	userId,
	isIncludedInApprovalUnits,
}: {
	asset?: IAssetRentRequestCardItem;
	userId?: string | number;
	isIncludedInApprovalUnits: boolean;
}) {
	if (!asset || !userId) return;

	const totalApprovingUnits = asset.approved + asset.disapproved + asset.pending;
	const isAllApproved = totalApprovingUnits !== 0 && asset.approved === totalApprovingUnits;

	switch (true) {
		case isAllApproved:
			return tooltipsText.allApproved;
		case !!asset.disapproved:
			return tooltipsText.atLeaseOneRejected;
		case !totalApprovingUnits:
			return tooltipsText.noApprovalUnits;
		case isIncludedInApprovalUnits:
			return tooltipsText.youIncluded;
		case !isIncludedInApprovalUnits:
			return tooltipsText.youNotIncluded;

		default:
			return '';
	}
}
